import { useCallback, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { spinHarryism, AgentLlmError } from '../../lib/llmHarryService';
import { buildHarryIsmSpinPrompt } from '../../lib/harry/harryPrompts';
import { harryPageContext } from '../../lib/harry/harryPageContext';
import { useHarryStore } from '../../stores/prioritization/harryStore';
import { getCurrentWorkspaceId } from '../../lib/supabaseSync';

export function useHarryIsmSpin(recentQuery?: string | null) {
  const location = useLocation();
  const config = useHarryStore((s) => s.config);
  const workspaceId = getCurrentWorkspaceId();
  const [ism, setIsm] = useState<string | null>(null);
  const [spinning, setSpinning] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const spin = useCallback(async () => {
    const { title, overview, pathname } = harryPageContext(location.pathname);
    if (!config?.enabled || !workspaceId) {
      setError('Enable Harry in Settings → Agents to spin the wheel.');
      return;
    }
    setSpinning(true);
    setError(null);
    try {
      const result = await spinHarryism({
        config,
        workspaceId,
        userPrompt: buildHarryIsmSpinPrompt({
          pageTitle: title,
          pageOverview: overview,
          pathname,
          recentQuery,
        }),
      });
      setIsm(result);
    } catch (err) {
      setError(
        err instanceof AgentLlmError
          ? err.message
          : 'Could not spin the wheel right now.',
      );
    } finally {
      setSpinning(false);
    }
  }, [config, workspaceId, location.pathname, recentQuery]);

  const clearIsm = useCallback(() => {
    setIsm(null);
    setError(null);
  }, []);

  return { ism, spinning, error, spin, clearIsm };
}
